import React, { Suspense } from 'react';
import { Row, Modal, ModalBody, ModalHeader} from 'reactstrap';
import axios from 'axios';
import cookies from '../../util/cookies';
import getConfig from "next/config";
// import './signInModal.scss'

const config = getConfig().publicRuntimeConfig;

const LoginModule = React.lazy(() => import('@giveindia/loginmodule'))
export default class SignInModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			emailOpen: false,
			userLoggedIn: false,			
		};
	}

	toggleEmail = () => {
		this.setState({
			emailOpen: !this.state.emailOpen,
		});
	};	

	onLoginSuccess = (res) => {    
		const {_csrf, identifier } = this.props;
		const token = res.token
		res.token && localStorage.setItem("CF_BEARER_TOKEN", token);
		if (window.location.search) {
			const queryString = window?.location?.search;
			const urlParams = new URLSearchParams(queryString);
			const UpdateIdfromUrl = urlParams.get('updateId');
			const DonationIdfromUrl = urlParams.get('donationId');
			const ProgramIdfromUrl = urlParams.get('programId');
			sessionStorage.getItem("UpdateIdfromUrl") === null ? sessionStorage.setItem("UpdateIdfromUrl", UpdateIdfromUrl) : null;
			sessionStorage.setItem("DonationIdfromUrl", DonationIdfromUrl)
			sessionStorage.getItem("ProgramIdfromUrl") === null ? sessionStorage.setItem("ProgramIdfromUrl", ProgramIdfromUrl) : null;
		}

		if(!identifier){
			axios({
				method: 'post',
				url: `/validate-signin`,
				data: {
					data: res,
					_csrf
				}
			}).then((res) => {					
				if (window.eventDispatcher) {
					window.eventDispatcher.dispatchEventSync('loginSuccess', {method: 'email-password'}, {amplitude: true});
				}
				window.location.reload();
			}).catch((error) => {				
				this.setState({
					userLoggedIn: false
				})
				// TODO: Throw error message 
			});		
		}
		else{
			axios({
				method: 'post',
				url: '/verify-email',
				data: {
					email: res.user.email,
					emailVerified: true,
					phone: res.user.phone,
					_csrf
				},
				withCredentials: true
			}).then((res, err) => {
				if (err || res.error) {
					// TODO: Do Nothing
				} else {										
					window.location.reload();
				}
			}).catch((error) => {				
				if(this.props && this.props.onError){					
					this.props.onError({						
						message: "Email is linked to another user. Please try again with a different email or login to a different account."
					})					
				}				
				return
			})
		}
  }

  onLoginFailure = (res) => {
    // window.location.reload()
	}

  loginMethods = [
    'EMAIL-OTP',
		'PHONE-OTP',
    'EMAIL-PASSWORD',
    'PHONE-PASSWORD',
    'SOCIAL-FACEBOOK',
    'SOCIAL-GOOGLE',    
  ]

  availableDomains = ['*']

	render() {

		return (
			<div>
				<Modal autoFocus isOpen={this.props.isOpen} toggle={() => this.props.toggleSignUpOpen()} className="sign-up-modal">
					<ModalHeader style={{ paddingBottom: '0' }} toggle={this.props.toggleSignUpOpen} />
					<ModalBody style={{ paddingTop: '0', paddingBottom: '0' }}>						
						<Suspense fallback={<div>Loading...</div>}>
							<LoginModule 
								onSuccess={e => this.onLoginSuccess(e)}
								onFailure={e => this.onLoginFailure(e)}								
								googleClientID={config.google_id}
								OTPLength={4}
								telCountryCode="IN"
								loginMethods={this.loginMethods}
								availableDomains={this.availableDomains}
								identifier={this.props.identifier || false}
								baseURL={config.fundraisersPlatformUrl}
							/>
						</Suspense>
					</ModalBody>
				</Modal>
			</div>
		);
	}
}
